export enum AppRoutes {
    HOME = "/",
    LOGIN = "/login",
    REGISTER = "/register",
    PAYMENT_SUCCESS = "/payment-success",
    PAYMENT_FAILED = "/payment-cancelled",
    CLIP = "/clip",
    TERMS_AND_CONDITIONS = "/tos",
    PRIVACY_POLICY = "/privacy",
    LICENSE = "/license",
    NOT_FOUND = "*",
    JOBS = "/jobs",
    DOCS = "/developers/docs",
    MANAGE_API = "/developers/api"
}